import type { SVGProps } from 'react'
import React from 'react'
import withIcon from './hoc/withIcon'

const Avatar: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_3126_22738)">
        <rect width="24" height="24" rx="12" fill="#EDF1F6" />
        <circle cx="12" cy="23" r="10" fill="#CFD9E4" />
        <circle cx="12" cy="10" r="6" fill="#CFD9E4" stroke="#EDF1F6" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_3126_22738">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

Avatar.displayName = 'Avatar'

export default withIcon(Avatar)
